<template>
   
  <x1_topo />
  <x2_awa_is />
  <x3_awa_forest_image />
  <x4_drink_the_air />
  <x5_susteinability v-if="true"/>


  <x6_two_bottles  v-if="true" />
  <x7_cta  v-if="true" />
  
  
  <j_email2  v-if="false"/>
  <b_drink_the_air   v-if="false" />
  <h_drink_awa    v-if="false" />
  <b_drink_the_air   v-if="false" />


  <x9_footer  v-if="true"/>
 
  </template>
  
  <script>
 
 import x1_topo from '@/components/x1_topo.vue'
 import x2_awa_is from '@/components/x2_awa_is.vue'
 import x3_awa_forest_image from '@/components/x3_awa_forest_image.vue'
 import x4_drink_the_air from '@/components/x4_drink_the_air.vue'
 import x5_susteinability from '@/components/x5_susteinability.vue'
 import x6_two_bottles from '@/components/x6_two_bottles.vue'
 import x7_cta from '@/components/x7_cta.vue'
 import x9_footer from '@/components/x9_footer.vue'



 import j_email2 from '@/components/j_email2.vue'
 import h_drink_awa from '@/components/h_drink_awa.vue'

  
  export default {
  
    name: 'AwaHome',
  
    components: {
      x1_topo,
      x2_awa_is,
      x3_awa_forest_image,
      x4_drink_the_air,
      x5_susteinability, 
      x6_two_bottles,
      j_email2,
      x9_footer,
      h_drink_awa,
      x7_cta,
    },
  
  
    data() {
      return {
        isNavFixed: false,
      };
    },
    mounted() {
      //window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
      handleScroll() {
        //this.isNavFixed = window.scrollY > 100; // Fixa o menu após 100px de scroll
      },
    },
    beforeUnmount() {
      //window.removeEventListener('scroll', this.handleScroll);
    },
  };
  </script>
  
   
   
  
  <style scoped>
  
  </style>